import classNames from "classnames";
import type { CMSPhotoDTO } from "~/CMSComponents/dto";
import classes from "./CMSImage.module.less";
import { IconButton, Link } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

interface Props extends Omit<CMSPhotoDTO, "type"> {
  className?: string;
}

export const CMSPhoto = (props: Props) => {
  const openInNewTab = props.openInNewTab;
  return (
    <div
      key={props.index}
      className={classNames(classes.card)}
      style={{
        width: props.getWidth(props.getWidthParam),
        marginRight: props.getMargin(props.relativeIndex, props.index),
      }}
    >
      <img className={classNames(classes.galleryImage)} src={props.imageUrl} />
      <div
        className={classNames(classes.photoFooter)}
        style={{
          opacity: props.getWidth(props.getWidthParam) == "100%" ? 1 : 0,
        }}
      >
        <>
          <div>
            <p className={classNames(classes.footerTitle)}>{props.title}</p>
            <p className={classNames(classes.footerSubTitle)}>{props.body}</p>
          </div>
          {props.url && (
            <Link href={props.url} target={openInNewTab ? "_blank" : undefined}>
              <IconButton
                variant="contained"
                color={"secondary"}
                size={"medium"}
                tabIndex={-1}
                className={classNames(classes.linkIcon)}
              >
                <OpenInNewIcon />
              </IconButton>
            </Link>
          )}
        </>
      </div>
    </div>
  );
};
